import React, { useState } from "react";
import { ColorPicker } from "../tools/common";


const ChannelItemManagement = ({ channel, updateList, deleteChannel, index }:any) => {

  const [channelName, setChannelName] = useState(channel.name);
  const [channelColor, setChannelColor] = useState(channel.color);
  const [channelAction, setChannelAction] = useState(channel.action);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChannelName(event.target.value);
    if(channel.key){
      setChannelAction("Update");
      updateList({ ...channel, name: event.target.value, action: "Update"}, index);
      return;
    }
    updateList({ ...channel, name: event.target.value}, index);
  };

  const handleColorChange = (newColor: string) => {
    setChannelColor(newColor);
    if(channel.key){
      setChannelAction("Update");
      updateList({ ...channel, action: "Update", color: newColor}, index);
      return;
    }
    updateList({ ...channel, color: newColor}, index);
  };

  const handleDelete = () => {
    if(channel.key){
      setChannelAction("Delete");
      updateList({ ...channel, action: "Delete"}, index);
      return;
    }
    deleteChannel(channel.timestamp);
  }

    return (
      <div className="channel-management-item">
        <span className="channel-info">
          <ColorPicker 
            value={channelColor} 
            onChange={handleColorChange}
            valueType="hex"
          />
          <input
          type="text"
          value={channelName}
          onChange={handleInputChange}
          />
        </span>
        {/* { channel.assignedSeats == 0 && <button className="delete-button" onClick={handleDelete}>🗑️</button> } */}
      </div>
    );
  };

export default ChannelItemManagement;